package com.anjuros.website.templates.template5.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity2
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Template5Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#6A3E3E", rgb = rgb(r = 106, g = 62, b = 62)),
    PrimaryLight(hex = "#B58A8A", rgb = rgb(r = 181, g = 138, b = 138)),
    Background(hex = "#FFF8F5", rgb = rgb(r = 255, g = 248, b = 245)),
    Background2(hex = "#F9E4E8", rgb = rgb(r = 249, g = 228, b = 232)),
    Cards(hex = "#FFFFFF", rgb = rgb(r = 255, g = 255, b = 255)),
    Accent(hex = "#E8CFC5", rgb = rgb(r = 232, g = 207, b = 197)),
    OpacityPrimary(hex = "#00A78E", rgb = argb(a = 0.8f, r = 0, g = 167, b = 142)),
    Secondary(hex = "#D98C9A", rgb = rgb(r = 217, g = 140, b = 154)),
    SecondaryLight(hex = "#F5D6DC", rgb = rgb(r = 245, g = 214, b = 220)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 249, g = 249, b = 249))
}

@Composable
fun Template5Theme.getColor():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template5Theme.getColorOpacity():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}

@Composable
fun Template5Theme.getColorOpacity2():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
         placeholderPrimaryColorOpacity2.rgb
}

@Composable
fun Template5Theme.getColorOpacityHex():String{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.hex
    else
        placeholderPrimaryColorOpacity.hex
}

@Composable
fun Template5Theme.getColorOpacity2Hex():String{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.hex
    else
        placeholderPrimaryColorOpacity2.hex
}
